function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M9.956 2.872c1.622-.881 3.649-2.505 4.726-1.612 1.096.907-.995 3.822-.995 3.822-1.389-4.88-4.739.394-5.175-.134-2.46-2.979-6.465 2.398-4.113 5.34 1.432 1.79 5.055-7.547 7.695-5.8.885.585 2.401 4.135.208 6.913-1.908 2.418-4.85 2.324-6.307 1.741-1.4.955-3.859 2.432-4.739 1.625-.587-.539-.141-1.795 1.105-3.713.322 4.227 3.63.71 4.08.878 1.116.357 3.5-1.557 2.93-4.208-.057-.943-3.924 4.979-5.466 3.856-.831-.606-2.476-4.026-.293-6.86 1.89-2.455 4.603-2.536 6.344-1.848z"
});

const SvgStarmemoryIconV2 = (_ref) => {
  let svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 16 16",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgStarmemoryIconV2, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/starmemory-icon-V2.3b5f664d.svg";
export { ForwardRef as ReactComponent };